import {
  Modal,
  Form,
  Button,
  message,
  Alert,
  Input,
  InputNumber,
  Select,
} from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../../../config/helpers/app/numberFormater";

const { Option } = Select;

const AddLocalPurchaseOrderItem = ({
  visible,
  handleAddRecord,
  handleCloseModal,
}) => {
  const {
    addLpoItemsSuccess,
    addLpoItemsLoading,
    addLpoItemsError,
    addLpoItemsMessage,
    localPurchaseOrdersDetails,
  } = useSelector((state) => state.localPurchaseOrdersState);
  const closeModal = () => handleCloseModal(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    values.created_at = new Date();
    values.local_purchase_order = localPurchaseOrdersDetails.id;
    handleAddRecord(values);
  };
  useEffect(() => {
    if (addLpoItemsSuccess && addLpoItemsMessage) {
      message.success(addLpoItemsMessage);
      form.resetFields();
    }
  }, [addLpoItemsSuccess, addLpoItemsMessage, form]);
  return (
    <div>
      <Modal
        title="ADD LOCAL PURCHASE ORDER ITEM"
        onCancel={closeModal}
        footer={null}
        open={visible}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          form={form}
          onFinish={onFinish}
        >
          {!addLpoItemsSuccess && addLpoItemsError && (
            <Alert
              className="m-2"
              showIcon
              type="error"
              message={addLpoItemsError}
            />
          )}
          <Form.Item
            label="Item"
            name={"item"}
            fieldKey={"item"}
            rules={[{ required: true, message: "Please select an item" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              className="w-100"
              allowClear
            >
              {localPurchaseOrdersDetails?.items?.map((item) => {
                return (
                  <Option value={item.id} key={item.id}>
                    {item.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Units"
            name={"units"}
            fieldKey={"units"}
            hasFeedback
            rules={[{ required: true, message: "Please add Units" }]}
          >
            <InputNumber precision={0} className="w-100" placeholder="Units" />
          </Form.Item>
          <Form.Item
            label="Unit Cost"
            name={"unit_cost"}
            fieldKey={"unit_cost"}
            hasFeedback
            rules={[{ required: true, message: "Please add a Unit Cost" }]}
          >
            <InputNumber
              precision={0}
              className="w-100"
              placeholder="Unit Cost"
            />
          </Form.Item>
          <Form.Item label="Total" shouldUpdate>
            {({ getFieldValue }) => {
              const unitCost = getFieldValue("unit_cost");
              const units = getFieldValue("units");
              const total_cost = parseInt(unitCost) * parseInt(units);
              return (
                <Input
                  readOnly
                  value={!isNaN(total_cost) ? numberWithCommas(total_cost) : 0}
                ></Input>
              );
            }}
          </Form.Item>
          <Form.Item
            label="Description"
            name={"description"}
            rules={[{ required: true, message: "Please add a Description" }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item className={"mt-3"} wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              loading={addLpoItemsLoading}
              htmlType="submit"
              type="primary"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddLocalPurchaseOrderItem;
